import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import AddGameConstraintForm from './ContentForm/ModalContent/AddGameConstraintForm'
import useFormSubmit from 'helper/Hooks/formSubmit'
import CustomModalFooter from 'components/global/CustomModalFooter'

const GameConstraintModal = () => {
  const { handleSubmit, form } = useFormSubmit()
  const { gameConstraintModal, setgameConstraintModal } = leagueEventStore(
    store => ({
      gameConstraintModal: store.gameConstraintModal,
      setgameConstraintModal: store.setgameConstraintModal,
    }),
  )

  const handleClose = () => {
    setgameConstraintModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={gameConstraintModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Game constraint"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <AddGameConstraintForm form={form} />
      </CustomModal>
    </>
  )
}

export default GameConstraintModal
